// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__OdUmn {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100dvh;
  justify-items: center;
  align-items: center;
}

.backgroundImage__dpYi2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  z-index: -1;
}

.backgroundImagePortrait__aF4mB {
  display: none;
}

.leftSide__zEZAB {
  display: flex;
  flex-direction: column;
  gap: 1vh;

  --icon-width: min(25vw, 400px);
  --icon-height: auto;
}

.rightSide__MPX4M {
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-left: 20%;
}

.rightSideHeader__pDFJW {
  display: flex;
  flex-direction: column;
  gap: 1vh;
  align-items: center;
  --icon-width: 80px;
  --icon-height: auto;
}

.rightSideContent__SPJAY {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 370px;
}

/* PORTRAIT MODE */
@media (max-width: 1050px) {
  .page__OdUmn {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .leftSide__zEZAB {
    --icon-width: 300px;
  }

  .rightSide__MPX4M {
    margin-left: 0;
  }

  .backgroundImagePortrait__aF4mB {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%; /* Cover the full width of the .page */
    height: 100%; /* Cover the full height of the .page */
    -o-object-fit: cover;
       object-fit: cover; /* Preserve aspect ratio while covering the area */
    z-index: -1; /* Ensure it's rendered behind other content */
  }

  .backgroundImage__dpYi2 {
    display: none;
  }

  @media (max-height: 1000px) {
    .leftSide__zEZAB {
      display: none;
    }

    .backgroundImagePortrait__aF4mB {
      display: none;
    }

    .page__OdUmn {
      grid-template-columns: 1fr;
      grid-template-rows: 7fr;
    }
  }
}

.divider__v9rxE {
  width: 100%;
  height: 2px;
  background-color: #d7e5ea;
}
`, "",{"version":3,"sources":["webpack://./src/containers/login-app/style.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE;IACE,0BAA0B;IAC1B,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW,EAAE,sCAAsC;IACnD,YAAY,EAAE,uCAAuC;IACrD,oBAAiB;OAAjB,iBAAiB,EAAE,kDAAkD;IACrE,WAAW,EAAE,8CAA8C;EAC7D;;EAEA;IACE,aAAa;EACf;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,0BAA0B;MAC1B,uBAAuB;IACzB;EACF;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B","sourcesContent":[".page {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  height: 100dvh;\n  justify-items: center;\n  align-items: center;\n}\n\n.backgroundImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: -1;\n}\n\n.backgroundImagePortrait {\n  display: none;\n}\n\n.leftSide {\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n\n  --icon-width: min(25vw, 400px);\n  --icon-height: auto;\n}\n\n.rightSide {\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  margin-left: 20%;\n}\n\n.rightSideHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 1vh;\n  align-items: center;\n  --icon-width: 80px;\n  --icon-height: auto;\n}\n\n.rightSideContent {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 370px;\n}\n\n/* PORTRAIT MODE */\n@media (max-width: 1050px) {\n  .page {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 2fr 1fr;\n  }\n\n  .leftSide {\n    --icon-width: 300px;\n  }\n\n  .rightSide {\n    margin-left: 0;\n  }\n\n  .backgroundImagePortrait {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%; /* Cover the full width of the .page */\n    height: 100%; /* Cover the full height of the .page */\n    object-fit: cover; /* Preserve aspect ratio while covering the area */\n    z-index: -1; /* Ensure it's rendered behind other content */\n  }\n\n  .backgroundImage {\n    display: none;\n  }\n\n  @media (max-height: 1000px) {\n    .leftSide {\n      display: none;\n    }\n\n    .backgroundImagePortrait {\n      display: none;\n    }\n\n    .page {\n      grid-template-columns: 1fr;\n      grid-template-rows: 7fr;\n    }\n  }\n}\n\n.divider {\n  width: 100%;\n  height: 2px;\n  background-color: #d7e5ea;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__OdUmn`,
	"backgroundImage": `backgroundImage__dpYi2`,
	"backgroundImagePortrait": `backgroundImagePortrait__aF4mB`,
	"leftSide": `leftSide__zEZAB`,
	"rightSide": `rightSide__MPX4M`,
	"rightSideHeader": `rightSideHeader__pDFJW`,
	"rightSideContent": `rightSideContent__SPJAY`,
	"divider": `divider__v9rxE`
};
export default ___CSS_LOADER_EXPORT___;
